'use client';
import { ColorSchemeContext } from '#pplx/frontend/aether/components/ColorSchemeProvider/useColorScheme.js';
import { useContext } from 'react';
/**
 * Hook to work with the user's preferred color scheme.
 *
 * In most cases, you should rely on CSS classes to hide and show content based
 * on the user's color scheme. Try to only use this hook when a complex layout
 * requires knowledge of the color scheme.
 *
 * @returns Settings to get the value of the current color scheme, the user's
 * preferred color scheme (if set), and methods to update the color scheme to
 * the user's preference or the system value.
 */
export function useColorScheme() {
    const context = useContext(ColorSchemeContext);
    if (!context) {
        throw new Error('Attempted to access ColorSchemeContext from useColorScheme() without adding <ColorSchemeProvider> to the tree.');
    }
    return context;
}
//# sourceMappingURL=useColorScheme.js.map